import Layout from '@/layout'
export default [
    {
        path: '/reports',
        component: Layout,
        children: [
            {
                path: '/reports',
                name: 'Report',
                component: () => import('@/views/report-contract/index'),
                meta: { title: 'Reports', icon: 'table' }
            }
        ]
    },
    {
        path: '/reports/:id',
        component: Layout,
        children: [
            {
                path: '/reports/:id',
                name: 'reportByContract',
                component: () => import('@/views/report-contract/detail'),
            }
        ]
    },
    {
        path: '/overview-report/:id',
        component: Layout,
        children: [
            {
                path: '/overview-report/:id',
                name: 'overviewReportByContract',
                component: () => import('@/views/report-contract/overviewReport'),
                meta: { title: 'Overview Report', icon: 'table' },
                hidden: true
            }
        ]
    },
    {
        path: '/detail-report/:id',
        component: Layout,
        children: [
            {
                path: '/detail-report/:id',
                name: 'detailReportByContract',
                component: () => import('@/views/report-contract/detailReport'),
                meta: { title: 'Detail Report', icon: 'table' },
                hidden: true
            }
        ]
    },
    {
        path: '/native-detail-report/:id',
        component: Layout,
        children: [
            {
                path: '/native-detail-report/:id',
                name: 'nativeDetailReportByContract',
                component: () => import('@/views/report-contract/nativeDetailReport'),
                meta: { title: 'Native Detail Report', icon: 'table' },
                hidden: true
            }
        ]
    },
    {
        path: '/result-report/:id',
        component: Layout,
        children: [
            {
                path: '/result-report/:id',
                name: 'resultReportByContract',
                component: () => import('@/views/report-contract/resultReport'),
                meta: { title: 'Result Report', icon: 'table' },
                hidden: true
            }
        ]
    },
    {
        path: '/attendance-report/:id',
        component: Layout,
        children: [
            {
                path: '/attendance-report/:id',
                name: 'attendanceReportByContract',
                component: () => import('@/views/report-contract/attendanceReport'),
                meta: { title: 'Attendance Report', icon: 'table' },
                hidden: true
            }
        ]
    },
    {
        path: '/employee-process-report/:id',
        component: Layout,
        children: [
            {
                path: '/employee-process-report/:id',
                name: 'employeeProcessReport',
                component: () => import('@/views/report-contract/reportProcessByEmployee'),
            }
        ]
    },
    {
        path: '/employee-result-report/:id',
        component: Layout,
        children: [
            {
                path: '/employee-result-report/:id',
                name: 'employeeResultReport',
                component: () => import('@/views/report-contract/reportResultByEmployee'),
            }
        ]
    },
]